const generateHours = () => {
  const hours = [];
  for (let i = 0; i < 24; i++) {
    const period = i < 12 ? "AM" : "PM";
    const hour = i % 12 === 0 ? 12 : i % 12; // Convert 24-hour format to 12-hour format
    hours.push(`${hour} ${period}`);
  }
  return hours;
};

export const HOUR = generateHours();

export const renderPercentChange = (today, yesterday) => {
  const percentChange =
    yesterday !== 0 ? ((today - yesterday) / yesterday) * 100 : 0;

  return (
    <span className={`${percentChange > 0 ? "text-success" : "text-dark"}`}>
      {percentChange > 0 ? "▲" : "▼"} {Math.abs(percentChange).toFixed(2)}%
    </span>
  );
}